import React from 'react';
import CrossIcon from 'components/icons/CrossIcon';
import classnames from 'classnames';
import CheckmarkIcon from 'components/icons/CheckmarkIcon';

const CSS = require('./FancyCheckbox.less');

interface FancyCheckboxProps {
  onClick?: (e: any) => void;
  className?: string;
  name: string;
  checked?: boolean;
  disabled?: boolean;
}

function FancyCheckbox({ onClick, className, name, checked, disabled }: FancyCheckboxProps) {
  const onClickCheckbox = () => {
    if (disabled || !onClick) {
      return;
    }
    onClick({
      target: {
        name: name,
        checked: !checked,
        type: 'checkbox',
      },
    });
  };

  return (
    <button
      data-test-id="FancyCheckbox"
      className={classnames(className, CSS.FancyCheckbox, {
        [CSS.Checked]: checked,
      })}
      type="button"
      onClick={onClickCheckbox}
    >
      <div
        className={CSS.Lever}
      >
        {checked ?
          <CheckmarkIcon className={CSS.checkMarkIcon} width={8} height={8}/> :
          <CrossIcon className={CSS.crossIcon} width={8} height={8}/>}
      </div>
    </button>
  );
}

export default FancyCheckbox;
